import { useEffect } from 'react';
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { ActiveTab, TabContainer } from '../ordersSetting/types';
import { Tabs } from '../ordersSetting/Ui/Tabs';
import { groupSettingTabs, tabURLS } from "./util/groupSettingsTabs";
import { useStyles } from "./styles";
import { GROUP_AREAS, GROUP_IMAGES, GROUP_TIPPING } from '../../const/URL.const';
import TippingComponent from '../tipping/TippingComponent';
import VenueAreasContainer from '../venueAreas/VenueAreasContainer';
import { Paper } from '@material-ui/core';
import { setActiveTabState } from './state';
import { useVenueGroups } from './useVenueGroups';
import GeneralForms from './GeneralForms';
import { GroupLogoSettings } from './GroupLogoSettings';


interface IGroupSettingsView{
  activeTab : ActiveTab,
  dispatch: any,
}

export function GroupSettingView({ activeTab, dispatch }: IGroupSettingsView) {

  const history = useHistory();
  const classes = useStyles();
  const { path , url } = useRouteMatch();
  const { id } = useVenueGroups(dispatch);
  const location = useLocation();

  const tabsProps = {
    ...groupSettingTabs,
    onChange: changeTab,
    activeTab,
  }

  const venueAreasProps = {
      label: 'forms.settings.VenueAreaRanges',
      keyName: 'table_layout',
      value: null,
      formProps: {
        buttonLabel:"merchant.buttons.createNewVenueArea",
        secondLabel: "forms.settings.venueAreas",
        message: "forms.settings.emptyVenueAreas",
        venue_group_id:id
    },
  }

  useEffect(() => {
    const tab = location.pathname.substring(location.pathname.lastIndexOf('/') + 1).toUpperCase();
    if(tab !== activeTab.key){
      dispatch(setActiveTabState({
        key:tab.length > 10 ? "GENERAL" : tab
      }));
    }
  // eslint-disable-next-line  
  },[location.pathname])


  function changeTab(tab: TabContainer) {
    const activeTab = {
      key: tab.key,
    };
    dispatch(setActiveTabState(activeTab));
    history.push(`${url}${tabURLS[tab.key]}`);
  }

  return (
    <div className={classes.settingsWrapper}>
      <Tabs {...tabsProps}/>
      <div className={classes.content}>
        <Switch>
          <Route exact path={path}>
            <GeneralForms dispatch ={dispatch}/>
          </Route>
          <Route exact path={`${path}${GROUP_TIPPING}`}>
            <TippingComponent venue_group_id={id} />
          </Route>
          <Route exact path={`${path}${GROUP_AREAS}`}>
            <Paper className={classes.areasWrapper}>
              <VenueAreasContainer  {...venueAreasProps} register={null as any}/>
            </Paper>
          </Route>
          <Route exact path={`${path}${GROUP_IMAGES}`}>
            <GroupLogoSettings dispatch ={dispatch}/>
          </Route>
        </Switch>
      </div>

    </div>
  )
}
